import { render, staticRenderFns } from "./obnovitdate.vue?vue&type=template&id=5d132346&scoped=true&"
import script from "./obnovitdate.vue?vue&type=script&lang=js&"
export * from "./obnovitdate.vue?vue&type=script&lang=js&"
import style0 from "./obnovitdate.vue?vue&type=style&index=0&id=5d132346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d132346",
  null
  
)

export default component.exports